export default __webpack_public_path__ + "static/media/jee_step_1.d97f26b3.svg";